import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleHalfFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCircleHalfFill"><Path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21V3ZM2 12C2 6.47715 6.47715 2 12 2C12.1764 2 12.3517 2.00457 12.5259 2.0136C17.8045 2.28732 22 6.65354 22 12C22 17.3465 17.8045 21.7127 12.5259 21.9864C12.3517 21.9954 12.1764 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCircleHalfFill;
